import Navigation from "../components/Navigation"
import { Link } from "react-router-dom"
import "./PartnerPage.scss"

const PartnerPage = () => {
  return (
    <div className="partner-page">
      <Navigation />

      {/* Hero Section */}
      <section className="partner-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Become a Cakoi's Partner</h1>
            <p className="hero-description">
              Join Malaysia's fastest-growing food franchise and start your journey to financial independence with our
              proven business model and comprehensive support system.
            </p>
            <div className="hero-features">
              <div className="feature-card">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="2" />
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </div>
                <h3>Low Investment</h3>
                <p>Start your business with minimal capital and maximum support</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" stroke="currentColor" strokeWidth="2" />
                    <polyline points="17,6 23,6 23,12" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </div>
                <h3>High Returns</h3>
                <p>Proven profit margins with growing market demand</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </div>
                <h3>Full Support</h3>
                <p>Complete training and ongoing business support</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Join Us Section */}
      <section className="why-join-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Join Cakoi's?</h2>
            <p className="section-subtitle">
              We provide everything you need to succeed in the food business, from training to marketing support and
              ongoing guidance.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <h3>What We Offer</h3>
              <div className="offer-list">
                <div className="offer-item">
                  <div className="offer-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" />
                    </svg>
                  </div>
                  <div className="offer-content">
                    <h4>Comprehensive Training</h4>
                    <p>2-week intensive training program covering all aspects of the business</p>
                  </div>
                </div>
                <div className="offer-item">
                  <div className="offer-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" />
                      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
                      <path
                        d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                        stroke="currentColor"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>
                  <div className="offer-content">
                    <h4>Marketing Support</h4>
                    <p>Complete marketing materials and digital marketing assistance</p>
                  </div>
                </div>
                <div className="offer-item">
                  <div className="offer-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                      <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="2" />
                    </svg>
                  </div>
                  <div className="offer-content">
                    <h4>Flexible Hours</h4>
                    <p>Choose your own operating hours and work-life balance</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="content-image">
              <img
                src="https://via.placeholder.com/500x400/CB0101/FFFFFF?text=Partner+Training"
                alt="Cakoi's partner training"
              />
            </div>
          </div>

          <div className="investment-details">
            <div className="investment-content">
              <div className="investment-info">
                <h3>Investment Details</h3>
                <div className="investment-list">
                  <div className="investment-item">
                    <span className="item-label">Initial Investment</span>
                    <span className="item-value">RM 15,000 - RM 25,000</span>
                  </div>
                  <div className="investment-item">
                    <span className="item-label">Equipment Package</span>
                    <span className="item-value">Included</span>
                  </div>
                  <div className="investment-item">
                    <span className="item-label">Training Program</span>
                    <span className="item-value">Free</span>
                  </div>
                  <div className="investment-item">
                    <span className="item-label">Ongoing Support</span>
                    <span className="item-value">Lifetime</span>
                  </div>
                </div>
              </div>
              <div className="roi-card">
                <div className="roi-content">
                  <h4>Expected ROI</h4>
                  <div className="roi-number">6-12</div>
                  <p>months to break even</p>
                  <div className="roi-disclaimer">
                    <p>*Based on average partner performance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Registration Form */}
      <section className="registration-section">
        <div className="container">
          <div className="form-container">
            <div className="form-header">
              <h2 className="section-title">Start Your Journey Today</h2>
              <p className="section-subtitle">
                Fill out the form below and our team will contact you within 24 hours to discuss your partnership
                opportunity.
              </p>
            </div>

            <div className="card registration-card">
              <div className="card-header">
                <h3>Partnership Application</h3>
                <p>Please provide your details and we'll get back to you soon</p>
              </div>
              <div className="card-content">
                <form className="registration-form">
                  <div className="form-row">
                    <div className="form-group">
                      <label>First Name *</label>
                      <input type="text" className="input" placeholder="Your first name" required />
                    </div>
                    <div className="form-group">
                      <label>Last Name *</label>
                      <input type="text" className="input" placeholder="Your last name" required />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Email Address *</label>
                      <input type="email" className="input" placeholder="your.email@example.com" required />
                    </div>
                    <div className="form-group">
                      <label>Phone Number *</label>
                      <input type="tel" className="input" placeholder="+60 12-345 6789" required />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>State *</label>
                      <select className="input" required>
                        <option value="">Select your state</option>
                        <option value="kuala-lumpur">Kuala Lumpur</option>
                        <option value="selangor">Selangor</option>
                        <option value="penang">Penang</option>
                        <option value="johor">Johor</option>
                        <option value="perak">Perak</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Investment Budget</label>
                      <select className="input">
                        <option value="">Select budget range</option>
                        <option value="15k-20k">RM 15,000 - RM 20,000</option>
                        <option value="20k-25k">RM 20,000 - RM 25,000</option>
                        <option value="25k-30k">RM 25,000 - RM 30,000</option>
                        <option value="30k+">RM 30,000+</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Business Experience</label>
                    <select className="input">
                      <option value="">Select your experience level</option>
                      <option value="none">No business experience</option>
                      <option value="some">Some business experience</option>
                      <option value="food">Food industry experience</option>
                      <option value="franchise">Franchise experience</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Why do you want to become a Cakoi's partner?</label>
                    <textarea
                      className="textarea"
                      placeholder="Tell us about your motivation and goals..."
                      rows="4"
                    ></textarea>
                  </div>

                  <div className="checkbox-group">
                    <label className="checkbox-label">
                      <input type="checkbox" />
                      <span className="checkmark"></span>I agree to the terms and conditions and privacy policy
                    </label>
                  </div>

                  <div className="checkbox-group">
                    <label className="checkbox-label">
                      <input type="checkbox" />
                      <span className="checkmark"></span>I would like to receive marketing communications about Cakoi's
                      opportunities
                    </label>
                  </div>

                  <button type="submit" className="btn btn-primary btn-lg">
                    Submit Application
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <h3 className="footer-title">Cakoi's</h3>
              <p className="footer-text">Start your food business journey with Malaysia's trusted cakoi franchise.</p>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Partnership</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/partner">Become a Partner</Link>
                </li>
                <li>
                  <a href="#">Investment Details</a>
                </li>
                <li>
                  <a href="#">Training Program</a>
                </li>
                <li>
                  <a href="#">Support System</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/menu">Menu</Link>
                </li>
                <li>
                  <a href="/#about">About Us</a>
                </li>
                <li>
                  <a href="/#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4 className="footer-heading">Contact</h4>
              <ul className="footer-links">
                <li>+60 12-345 6789</li>
                <li>partner@cakois.com</li>
                <li>Kuala Lumpur, Malaysia</li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Cakoi's. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default PartnerPage
